mergeIntoStore